export default {
  state: () => ({
    isOpen: false,
    title: '',
    description: '',
    secondaryAction: null
  }),
  mutations: {
    SHOW_GLOBAL_DIALOG(state, { title, description, secondaryAction }) {
      state.title = title || ''
      state.description = description || ''
      state.secondaryAction = secondaryAction || null
      state.isOpen = true
    },
    CLOSE_GLOBAL_DIALOG(state) {
      state.isOpen = false
    }
  },
  actions: {
    showGlobalDialog({ commit }, payload) {
      commit('SHOW_GLOBAL_DIALOG', payload)
    },
    closeGlobalDialog({ commit }) {
      commit('CLOSE_GLOBAL_DIALOG')
    }
  }
}
